import React from "react";
import "./Weather.css";
import FormattedDate from "./FormattedDate";
import WeatherUnit from "./WeatherUnit";
import Forecast from "./Forecast";

export default function Weather(props) {
  if (props.temperature) {
    return (
      <div className="Weather">
        <h2>Dude, this is your weather:</h2>
        <h1>{props.city}</h1>
        <FormattedDate time={props.time} />
        <p>
          The Weather Description in {props.city} is{" "}
          <strong>{props.description}</strong>.
        </p>
        <div className="row">
          <div className="col-6">
            <strong>
              <WeatherUnit celsius={props.temperature} />
            </strong>
            .{" "}
            <img
              src={`http://shecodes-assets.s3.amazonaws.com/api/weather/icons/${props.icon}.png`}
              alt={props.description}
            />
          </div>
          <div className="col-6">
            <ul>
              <li> Humidity: {props.humidity}%.</li>
              <li> Wind: {props.wind}km/h.</li>
            </ul>
          </div>
        </div>
        <Forecast city={props.city} />
      </div>
    );
  } else {
    return <p className="Weather">Loading...</p>;
  }
}
